import { OfferAnswerType } from '@models/winnerSelection/ITableDemand';

/**
 * Подпись ранга предложения для шапки колонки.
 *
 * - rank=1 → "Лидер"
 * - rank=2 → "Второй"
 * - rank=3 → "Третий"
 * - rank≥4 → "" (цифра ранга уже отображается рядом в кружке, дублировать не нужно)
 * - rank некорректный → ""
 */
export const rankLabel = (rank: number | string): string => {
    const n = typeof rank === 'string' ? parseInt(rank, 10) : rank;
    if (n === 1) return 'Лидер';
    if (n === 2) return 'Второй';
    if (n === 3) return 'Третий';
    return '';
};

const isoDateRe = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/;
const ruDateRe = /^(\d{1,2})[.\-/](\d{1,2})[.\-/](\d{4}|\d{2})(?:[ T](\d{1,2}):(\d{1,2}))?/;

const pad2 = (value: string | number): string => String(value).padStart(2, '0');

const formatAnswerDate = (value: string, withTime: boolean): string => {
    const raw = value.trim();

    const iso = raw.match(isoDateRe);
    if (iso) {
        const formattedDate = `${iso[3]}.${iso[2]}.${iso[1]}`;
        const formattedTime = iso[4] && iso[5] ? `${iso[4]}:${iso[5]}` : '';
        return withTime && formattedTime ? `${formattedDate} ${formattedTime}` : formattedDate;
    }

    const ru = raw.match(ruDateRe);
    if (ru) {
        const year = ru[3].length === 2 ? `20${ru[3]}` : ru[3];
        const formattedDate = `${pad2(ru[1])}.${pad2(ru[2])}.${year}`;
        const formattedTime = ru[4] && ru[5] ? `${pad2(ru[4])}:${pad2(ru[5])}` : '';
        return withTime && formattedTime ? `${formattedDate} ${formattedTime}` : formattedDate;
    }

    return value;
};

export const formatOfferAnswerValue = (value: string | null | undefined, answerType: OfferAnswerType): string => {
    if (!value) return '';

    if (answerType === 'date') {
        return formatAnswerDate(value, false);
    }

    if (answerType === 'datetime') {
        return formatAnswerDate(value, true);
    }

    return value;
};
